import { useContext } from 'react';
import { FavouriteProductsContext } from '../contexts';

// Exports hook which uses favouriteContext
export function useFavouriteProducts() {
  return useContext(FavouriteProductsContext);
}
